module.exports = __webpack_public_path__ + "img/bg_10.5f15ab27.png";